// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_t7-0";